import arhiteh_header from "../../../images/domain/arhiteh_header.png";

export const invoiceHeaderFooterMapping = {
    "Adriateh d.o.o.": {
        header: arhiteh_header,
        footer: `
            <p>ADRIATEH društvo s ograničenom odgovornošću za zastupanje, trgovinu i usluge upisan u Trgovačkom sudu u Zagrebu: Tt-15/24008-4 MBS: 080136018</p>
            <p>Temeljni kapital: €423.250,00 uplaćen u cijelosti. Predsjednik uprave: Goran Rebić, Članovi uprave: Z. Švraka, M. Krivičić</p>
            <p>PRIVREDNA BANKA ZAGREB d.d. IBAN: HR4523400091110072075</p>
        `
    },
}